<form autocomplete="off" [formGroup]="callForm">
  <mat-form-field class="w-full" appearance="outline">
    <mat-label>Buscar: <b>(Razão Social, Nome Fantasia, CNPJ/CPF, Email) </b> </mat-label>
    <input 
      matInput
      placeholder="Comece a digitar"
      formControlName="search"
      [matAutocomplete]="auto"
      (ngModelChange)="searchItems($event)"
    >
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option 
        *ngFor="let item of items" 
        [value]="item.name"
        (click)="selectBusinessFromSearch(item)"
        >
        {{ item.name }} ({{item.fantasy_name}}) - {{ item.cnpj }}
      </mat-option>
    </mat-autocomplete>
    <button type="button" matSuffix mat-icon-button (click)="changeBusiness()">
      <mat-icon>sync</mat-icon>
    </button>
  </mat-form-field>

  <!-- <mat-form-field style="width: 100%;" appearance="outline" color="primary" >
    <mat-label>Buscar: <b>(Razão Social, Nome Fantasia, CNPJ/CPF, Email)</b></mat-label>
    <input
      matInput
      formControlName="search"
      placeholder="Uma busca!"
      autocomplete="off"
      (ngModelChange)="searchItems($event)"
    >
    <mat-hint>Resultados: {{ items.length }}</mat-hint>
  </mat-form-field>
</form>
<table *ngIf="items.length > 0" mat-table [dataSource]="items" class="mat-elevation-z1" style="width: 100%;">
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef>#</th>
    <td mat-cell *matCellDef="let element"> {{element.id}} </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Empresa</th>
    <td mat-cell *matCellDef="let element"> {{element.name}} ({{element.fantasy_name}}) </td>
  </ng-container>

  <ng-container matColumnDef="cnpj">
    <th mat-header-cell *matHeaderCellDef>CNPJ</th>
    <td mat-cell *matCellDef="let element"> {{element.cnpj | mask:'CPF_CNPJ'}} </td>
  </ng-container>

  <ng-container matColumnDef="options">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <button
        mat-icon-button
        color="primary"
        aria-label="Select the business"
        (click)="selectBusinessFromSearch(element)"
      >
        <mat-icon>check_circle</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>-->
